import React from 'react';
import ReactDOM from 'react-dom/client';
import { BrowserRouter as Router } from 'react-router-dom';
import App from './App';
import { StrictMode } from 'react';
import { GoogleOAuthProvider } from '@react-oauth/google';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
    <GoogleOAuthProvider clientId="862090443322-4rco6hge6es6ur7do0lkqa84093liq00.apps.googleusercontent.com">
        <StrictMode>
            <Router>
                <App />
            </Router>
        </StrictMode>
    </GoogleOAuthProvider>
);
